<template>
  <section class="component-course-details">
    <app-loading :isFull="true" v-if="isLoading"/>
    <!-- v-if="scrolled" -->
    <div class="fixed-item" v-if="scrolled">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <h2 class="text-right rtl mb-0">
              <button
                class="btn-favorite"
                @click="setFavorite(item)"
                v-ripple
                :title="$t('button.favorite')"
              >
                <i class="flaticon-favorite" v-if="!isHeart"></i>
                <i class="flaticon-heart-2" v-else></i>
              </button>
              {{item.course_title}}
            </h2>
          </div>
          <div class="col-sm-12" v-if="false && isMobile">
            <div class="form-action no-gutters d-flex">
              <div class="col-6 px-1 text-center">
                <button
                  @click="addBasketCart(item)"
                  class="btn-addCart bttn-unite rounded bttn bttn-primary btn-block"
                  v-ripple
                  :title="$t('button.addCart')"
                >{{item.course_price | currency}}</button>
              </div>
              <div class="col-3 px-1 text-center">
                <button
                  class="bttn-fill bttn bttn-success btn-block"
                  v-ripple
                  :title="$t('button.addCart')"
                  @click="$emit('getEnroll',item)"
                >
                  <i class="mdi mdi-cart-plus"></i>
                </button>
              </div>
              <div class="col-3 px-1 text-center">
                <!-- to="/course-details" -->
                <button
                  @click="$emit('getEnroll',item)"
                  class="d-inline-block bttn-fill bttn bttn-primary btn-block"
                  v-ripple
                  :title="$t('button.courseStart')"
                >
                  <i class="mdi mdi-clock-start"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="banner-course-details">
      <div class="jumbotron jumbotron-fluid course-details-jumbotron">
        <div class="container">
          <div class="course-details-banner">
            <div class="row">
              <div class="col-12 col-lg-8">
                <div class="content-headeing">
                  <h1 class="rtl text-right">
                    <!-- @mouseover="isHeart = !isHeart" @mouseout="isHeart = !isHeart" -->
                    <button class="btn-favorite" @click="setFavorite(item)" v-ripple>
                      <i class="flaticon-favorite" v-if="!isHeart"></i>
                      <i class="flaticon-heart-2" v-else></i>
                    </button>
                    <span class="font-20">{{item.course_title}}</span>
                    <div class="font-18">
                      <router-link class="text-white" :to="'/user/'+item.creator_id">
                        مدرس :
                        <span
                          class="text-white"
                        >{{item.fullname ? item.fullname : 'در حال بار گذاری ... '}}</span>
                      </router-link>
                    </div>
                  </h1>
                  <!-- <p class="rtl text-right">دیگر توضیحات دوره ...</p> -->
                  <div class="start-box rtl text-right">
                    <star-rating
                      class="d-inline-block"
                      :rtl="true"
                      :read-only="true"
                      :star-size="20"
                      :show-rating="false"
                      :increment="0.01"
                      v-model="item.rate"
                      :active-color="'#f4c150'"
                      :rounded-corners="false"
                      :inactive-color="'#ccc'"
                    />
                    <p class="d-inline-block rtl text-right">
                      {{Math.round(item.rate*10)/10}}
                      <!-- {{$t('word.of')}} 20 {{($t('word.rate'))}} -->
                    </p>
                  </div>
                  <span
                    class="description-info font-16 text-justify text-white"
                    v-html="item.course_description_lite"
                  ></span>
                  <!-- <span class="font-14 text-right d-block  text-white">  </span> -->
                </div>
              </div>
              <div class="col-lg-4" ref="parentSidebar">
                <div class="panel-card video-box-panel p-0">
                  <div class="box-video box-shadow" @click="playDemo(item)">
                    <div class="play-free">
                      <i class="flaticon-play"></i>
                      <span>پیش نمایش دوره</span>
                    </div>

                    <div
                      class="image"
                      :style="{ backgroundImage: `url('${images}')` }"
                      :title="item.course_title"
                    ></div>
                    <img :src="images" :alt="item.course_title">
                    <!-- <img class="card-img-top" :src="appUrl.media +'/'+ item.Img" :alt="item.course_title_en +'|'+item.course_title" /> -->
                  </div>
                  <div
                    class="course-details-info sidebar px-3"
                    ref="sidebar"
                    :class="sidebarClass"
                    :style="sidebarStyle"
                  >
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="form-action form-action-center w-100">
                        <!-- <button class="bttn-unite rounded bttn bttn-primary" v-ripple  :title="$t('button.addCart')">
                          400,000 {{$t('word.rial')}}
                        </button>-->
                        <div class="box-price text-center clearfix mb-3">
                          <span class="discount" v-if="false">
                            20000
                            <i>{{$t('word.rial')}}</i>
                          </span>
                          <!-- <span class="cash" v-if="item.course_price !== 0">
                            {{item.course_price | currency}}
                            <i>{{$t('word.rial')}}</i>
                          </span>-->
                        </div>
                        <button
                          @click="addBasketCart(item)"
                          v-if="item.course_price !== 0"
                          class="bttn-fill align-items-center justify-content-center w-100 d-flex mb-1 bttn bttn-success"
                          v-ripple
                          :title="$t('button.addCart')"
                        >
                          <i class="flaticon-add-to-cart icon-24 ml-1"></i>
                          <span class="font-16">افزودن به سبد خرید</span>
                        </button>

                        <button
                          v-else
                          @click="$emit('startEnroll',item)"
                          class="font-16 bttn-block bttn-fill bttn bttn-primary"
                          v-ripple
                          :title="$t('button.courseStart')"
                        >
                          <i class="flaticon-list-2"></i>
                         ثبت نام رایگان در دوره
                        </button>
                        <m-check-offer-code
                          v-if="item.course_price !== 0"
                          :price="item.course_price"
                        />

                        <div class="row pt-3" v-if="false && item.course_price !== 0">
                          <div class="col-12">
                            <div class="group-form">
                              <!-- v-validate="'required'" -->
                              <input
                                type="text"
                                name="offerCode"
                                :class="{active:offerCode != '' }"
                                v-model="offerCode"
                                @keyup.enter="chechkOfferCode"
                              >
                              <span class="bar"></span>
                              <label>کد تخفیف دارید؟</label>
                              <!-- <span v-if="errors.has('offerCode')" class="is-danger">فیلد نباید خالی باشد</span> -->
                            </div>
                          </div>
                          <div class="col-12">
                            <button
                              class="align-items-center justify-content-center w-100 d-flex mb-1 bttn-fill bttn bttn-warning font-14"
                              @click="chechkOfferCode"
                              v-ripple
                            >
                              <i class="flaticon-discount-1 ml-1"></i>
                              اعمال تخفیف
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="dec-this-course clearfix mt-3 text-rtl text-right">
                      <ul>
                        <!-- <li>
                          <i
                            :class="['ml-1 mr-2 ', {'icon-22 ml-2 flaticon-remove':!item.downloadable,'icon-22 ml-2 flaticon-check-2':item.downloadable}]"
                          ></i>
                          امکان دانلود ویدئوهای دوره : {{item.downloadable ? 'دارد' : 'ندارد'}}
                        </li>-->
                        <li class="d-flex">
                          <i class="icon-22 ml-2 flaticon-clock ml-1 mr-2"></i>
                          <span>{{item.course_duration | duration}} فیلم آموزشی</span>
                        </li>
                        <li>
                          <i class="icon-22 ml-2 flaticon-level ml-1 mr-2"></i>
                          سطح {{item.level | level}}
                        </li>
                        <li v-if="counts">
                          <i class="icon-22 ml-2 flaticon-film ml-1 mr-2"></i>
                          تعداد فصل {{counts.season_count}}
                        </li>
                        <li v-if="counts">
                          <i class="icon-22 ml-2 flaticon-video-player-1 ml-1 mr-2"></i>
                          تعداد قسمت {{counts.lecture_count}}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="container mb-1">
        <div class="row">
          <div class="col-12 col-lg-8 mb-5">
            <what-will-i-learn :items="goals"/>
          </div>
        </div>
      </div>
    </section>
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="panel-card">
            <header>
              <h3 class="text-right font-18">توضیحات دوره :</h3>
            </header>
            <article>
              <p class="font-14 content-html text-right" v-html="item.course_description"></p>
            </article>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8">
          <!-- <requirements :subject="'پیام های دوره'" :icon="'minus'" :items="message" /> -->
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12 col-lg-8">
          <requirements :subject="'پیش نیاز های دوره'" :icon="'checkbox-multiple-marked-outline'" />
        </div>
      </div>-->
      <!-- <div class="row">
        <div class="col-12 col-lg-8">
          <requirements :subject="'مخاطبان دوره ؟'" :icon="'checkbox-multiple-blank-circle-outline'" />
        </div>
      </div>-->
      <div class="row">
        <div class="col-12 col-lg-8">
          <div class="list-course-collapse mb-4">
            <list-course-collapse/>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <header class="text-right mb-4">
            <h1 class="font-20">درباره {{instractors.length > 1 ? 'مدرسین' : 'مدرس' }}</h1>
          </header>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-8">
          <instructor v-if="instractors"/>
        </div>
      </div>
      <div class="row" v-if="comments.length > 0">
        <div class="col-12 col-lg-8">
          <header>
            <h2 class="rtl text-right mb-2 font-20">{{$t('word.comments')}}</h2>
          </header>
          <comments :item="comment" v-for="comment in comments" :key="comment.id"/>
        </div>
      </div>
      <!-- <div class="row">
        <div class=" p-0 col-12 col-lg-8">
          <contact-form :action="true" :inputs="reviewsForm" :title="'فرم ارسال نظر'" class="mb-4" />
        </div>
      </div>-->
    </div>
  </section>
</template>

<script>
import listCourseCollapse from "cp/min-component/list-course-collapse.vue";
import whatWillILearn from "cp/min-component/what-will-i-learn.vue";
import requirements from "cp/requirements.vue";
import instructor from "cp/instructor.vue";
import comments from "cp/comments.vue";
import contactForm from "cp/contact-form.vue";
import MIAddToBasket from "./icons/add-to-basket";
import MCheckOfferCode from "cp/min-component/check-offer-code";
var vm;
export default {
  name: "course-details",
  components: {
    MCheckOfferCode,
    MIAddToBasket,
    listCourseCollapse,
    whatWillILearn,
    requirements,
    instructor,
    comments,
    contactForm
  },
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    goals: {
      type: Array,
      default: () => []
    },
    message: {
      type: Array,
      default: () => []
    },
    listCourse: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      offerCode: "",
      green: "#4caf50",
      blue: "#007791",
      white: "#fff",
      fillColor: "#fff",
      fillColor2: "#fff",
      creator: {},
      isLoading: false,
      scrolled: false,
      starVal: 2.4,
      isHeart: false,
      sidebarStyle: {},
      rectSidebar: {},
      stoperRec: {},
      stoper: { stop: true, top: 0 },
      sidebar: {
        height: 0,
        windowHeight: 0,
        windowScrollTop: 0
      },
      reviewsForm: [
        {
          type: "rate",
          name: "rate",
          label: "امتیاز شما به این دوره",
          model: 1,
          col: "12"
        },
        {
          type: "textarea",
          name: "msg",
          label: "نظر خود را مطرح کنید",
          msg: "لطقا فرم را پر کنید",
          model: "",
          col: "12",
          rule: "required"
        }
      ]
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  watch: {
    windowWidth() {
      this.calcSidebar();
    },
    isMobile(val) {
      if (val) {
        this.sidebarStyle = {};
      }
    },
    stoper(val) {
      let sidebar = this.$refs.parentSidebar;
      if (val.stop && !this.isMobile) {
        this.sidebarStyle = {
          width: this.offset(sidebar).width - 30 + "px",
          top: val.top + "px"
        };
      } else {
        this.sidebarStyle = {
          width: this.offset(sidebar).width - 30 + "px"
        };
      }
    },
    scrolled(val) {
      let sidebar = this.$refs.parentSidebar;
      if (val && !this.isMobile) {
        this.sidebarStyle = {
          width: this.offset(sidebar).width - 30 + "px"
        };
      } else {
        this.sidebarStyle = {};
      }
    }
  },
  filters: {
    duration: function (value) {
      if (!value) return ''
      var time = value.split(':')
      // if(time[0] === 0)
      if (parseInt(time[0]) === 0) {
        return `${value} دقیقه`
      } else {
        return `${value} ساعت`
      }
    }
  },
  mounted() {
    vm = this;
    this.calcSidebar();
    this.checkFavorite();
    // if (this.isLogin) {
    // }
  },
  computed: {
    singelItem() {
      return this.$store.state.basket.singleItem;
    },
    images() {
      return this.appUrl.media + "/" + this.item.Img;
    },
    instractors() {
      return this.$store.state.courses.instractor;
    },
    comments() {
      return this.$store.state.contentCourses.comments;
    },
    counts() {
      return this.$store.state.courses.counts;
    },
    windowWidth() {
      return this.$store.state.layout.windowWidth;
    },
    isMobile() {
      return this.windowWidth < 992;
    },
    sidebarClass() {
      if (this.isMobile) {
        return {};
      }
      let sidebar = this.$refs.parentSidebar;
      if (
        this.sidebar.windowScrollTop >= 300 &&
        this.sidebar.windowScrollTop + this.rectSidebar.height <=
        this.stoperRec.top - 75
      ) {
        this.stoper = { stop: false, top: 0 };
        return { "fixed-top-box": true };
      }
      if (
        this.sidebar.windowScrollTop + this.rectSidebar.height >=
        this.stoperRec.top - 75
      ) {
        if (!this.stoper.stop) {
          this.stoper = {
            stop: true,
            top: this.sidebar.windowScrollTop - this.rectSidebar.height / 2 + 80
          };
        }
        return { "fixed-top-down": true };
      }
    }
  },
  methods: {

    async chechkOfferCode() {
      this.isLoading = true;
      let data = await this.$store.dispatch("basket/checkOfferCode", {
        code: this.offerCode,
        course_id: parseInt(this.$route.params.id)
      });
      this.isLoading = false;
    },
    removeDuplicates(myArr, prop) {
      if(!myArr) return ''
      return myArr.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },

    async playDemo(item) {
      this.isLoading = true;
      let { data } = await axios.post(`/lecture/get-free-demo`, {
        course_id: item.id
      });
      this.isLoading = false;
      if (data.state !== 200) return;
      this.playVideo(data.video);
    },
    async checkFavorite() {
      // if (!this.isLogin) {
      //   alert('شما لاگین نیستیم')
      // }
      let { data } = await axios.post(`/wishlist/is`, {
        course_id: this.$route.params.id
      });
      this.isHeart = data.result;
    },
    async setFavorite(item) {
      if (!this.isLogin) {
        this.$router.push(
          "/v1/login?callBackUrl=" + this.$route.path + "&setFavorit=" + item.id
        );
      }
      if (this.isHeart) {
        await this.$store.dispatch("courses/removeFavorite", item.id);
        this.isHeart = false;
      } else {
        await this.$store.dispatch("courses/addToFavorite", item.id);
        this.isHeart = true;
      }
    },
    calcSidebar() {
      let sidebar = this.$refs.parentSidebar;
      this.sidebar.height = this.offset(sidebar).height;
      this.sidebar.windowHeight = window.innerHeight;
    },
    // handleResize () {
    //   this.calcSidebar()
    // },
    handleScroll(event) {
      this.scrolled = this.sidebar.windowScrollTop >= 193;
      this.sidebar.windowScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.rectSidebar = this.offset(this.$refs.sidebar);
      this.stoperRec = this.offset(document.querySelector("footer"));
    },
    offset(el) {
      var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      return {
        top: rect.top + scrollTop,
        left: rect.left + scrollLeft,
        height: rect.height,
        bottom: rect.height + rect.top + scrollTop,
        width: rect.width
      };
    }
  }
};
</script>

<style lang="less">
@import (reference) "../assets/css/variable.less";
.component-course-details {
  .banner-course-details {
    position: relative;
  }
  .course-details-jumbotron {
    position: relative;
    background: url("../assets/img/goran-ivos-343495-unsplash.jpg") no-repeat
      center;
    background-attachment: fixed;
    background-size: cover;
    z-index: 0;
    height: 335px;
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.534);
    }
  }
  .btn-favorite {
    background: transparent;
    border: none;
    cursor: pointer;
    i {
      transition: transform 200ms ease-in-out, box-shadow 400ms ease-in;
      color: @red;
    }
    &:hover {
      i {
        transform: scale(1.3);
      }
    }
  }
  .course-details-banner {
    position: relative;
    z-index: 2;
    height: 160px;
    h1 {
      color: #fff;
    }
    p {
      color: #fff;
    }
  }
  .box-video {
    position: relative;
    cursor: pointer;
    padding-top: 77.5555%;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
    }
    &:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.534);
      z-index: 4;
    }
    .icon-play {
      color: #fff;
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      width: 85px;
      height: 85px;
      z-index: 4;
      &:before {
        transition: transform 200ms ease-in-out, box-shadow 400ms ease-in;
        width: 85px;
        height: 85px;
        border-radius: 100%;
        background: fade(@green, 60);
        text-align: center;
        line-height: 80px;
        display: block;
        box-shadow: 0px 0px 5px 0px rgba(1, 1, 1, 0.15);
      }
    }
    .image {
      position: absolute;
      top: 0;
      right: 0;
      width: 100%;
      height: 100%;
      background-position: 50%;
      background-size: cover;
    }
    &:hover {
      .icon-play {
        &:before {
          transform: scale(1.5);
          box-shadow: 0px 0px 10px 0px rgba(1, 1, 1, 0.4);
        }
      }
    }
  }
  .course-details-info {
    // background: #fff;
    transition: all 0.1s ease-in;
    p {
      color: #010101;
    }
  }
}
.fixed-item {
  position: fixed;
  right: 0;
  left: 0;
  top: 60px;
  background-color: #fff;
  padding: 10px 15px;
  box-shadow: 0px 0px 5px 0px rgba(1, 1, 1, 0.15);
  z-index: 6;
  h2 {
    font-size: 18px;
    font-weight: bold;
    height: 45px;
    line-height: 45px;
    i {
      position: relative;
      top: 2px;
    }
  }
}

.sidebar {
  max-width: 380px;
  background-color: #fff;
}
.fixed-top-box {
  position: fixed;
  top: 120px;
  background-color: #fff;
}
.fixed-top-down {
  position: absolute;
}

@media screen and (max-width: 992px) {
  .component-course-details .course-details-jumbotron {
    height: auto;
  }
  .component-course-details .panel-card.video-box-panel {
    width: 50%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .description-info {
    display: block;
    overflow: auto;
    height: 50px;
  }
  .sidebar {
    max-width: inherit;
  }
  .component-course-details {
    .course-details-jumbotron {
      position: relative;
      background-image: none; // url("../assets/img//goran-ivos-343495-unsplash.jpg") no-repeat
      // center;
      &:before {
        background: linear-gradient(#29303b, #29303b, #29303b);
      }
    }
    .course-details-banner {
      height: auto;
    }
  }
}
@media screen and (max-width: 768px) {
  .component-course-details .panel-card.video-box-panel {
    width: 80%;
  }
  .component-course-details {
    .fixed-item {
      h2 {
        font-size: 16px;
        height: 25px;
        line-height: 25px;
      }
      .form-action {
        button,
        a {
          font-size: 12px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .component-course-details .panel-card.video-box-panel {
    width: 100%;
  }
  .component-course-details {
    .fixed-item {
      h2 {
        height: auto;
        line-height: 10px;
        font-size: 12px;
      }
    }
  }
}
.play-free {
  position: absolute;
  display: flex;
  top: 0;
  bottom: 0;
  height: 50px;
  margin: auto;
  left: 0;
  right: 0;
  z-index: 4;
  justify-items: center;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.534);
  &:before,
  &:after {
    transition: all 0.3s ease-in-out;
  }
  &:after {
    background-color: rgba(0, 0, 0, 0.5);
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    z-index: -1;
    animation: bgBtnFree2 4s linear infinite;
  }

  &:before {
    background-color: rgba(255, 255, 255, 0.5);
    content: "";
    height: 100%;
    display: block;
    width: 0;
    animation: bgBtnFree 3s linear infinite;
    position: absolute;
    z-index: 1;
  }
  &:hover {
    &::before {
      transition: all 0.3s ease-in;
      width: 60%;
    }
    &::after {
      transition: all 0.3s ease-in;
      width: 100%;
    }
  }
  i {
    color: #fff;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);

    margin-left: 10px;
    &:before {
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
      font-size: 30px;
    }
    display: block;
  }
  span {
    color: #fff;
    margin-bottom: 0;
    font-size: 20px;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.4);
    margin-top: -8px;
  }
}
@keyframes bgBtnFree {
  0% {
    width: 0;
  }
  50% {
    width: 40%;
  }
  // 20% {
  //   width: 20%;
  // }
  // 60% {
  //   width: 40%;
  // }
  100% {
    width: 0;
  }
}
@keyframes bgBtnFree2 {
  0% {
    width: 0;
  }
  50% {
    width: 100%;
  }
  // 20% {
  //   width: 40%;
  // }
  // 60% {
  //   width: 60%;
  // }
  // 70% {
  //   width: 100%;
  // }
  100% {
    width: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course-details.vue